module.exports = __webpack_public_path__ + "static/media/bubble.987bd723.svg";